<template>
    <div style="width: 100%; height:auto;">
        <div class="head">
            <!-- 比赛图像 -->
            <div style="width:225px; height:66px;">
                <img style="cursor: pointer;" width="100%" height="100%" :src="content.image" alt="AL萌新赛" @click="ClickMeGoContestPage">
            </div>      
            <!-- 比赛的文字介绍 -->
            <div style="margin-left:20px; height:75%; width:48%;">
                <div style="font-size:14px; color:#333333; font-size:18px; cursor: pointer;"  @click="ClickMeGoContestPage">
                AL-{{content.title}}
                </div>
                <div style="font-size:14px; color:#8690A8; margin-top:4px">
                    <i class="el-icon-eleme"></i> 
                    报名时间:{{content.startTime}} 至 {{content.closeTime}}
                    <!-- {{}}年{{}}月{{}}日 {{}}:{{}} 至 {{}}年{{}}月{{}}日 {{}}:{{}} -->
                </div>
                <div style="font-size:14px; color:#8690A8; margin-top:4px">
                    <i class="el-icon-message-solid"></i> 
                    比赛时长:{{content.time}}<!-- {{}}年{{}}月{{}}日 {{}}:{{}} 至 {{}}年{{}}月{{}}日 {{}}:{{}} -->
                </div>
                <div style="font-size:14px; color:#8690A8; margin-top:4px">
                    <i class="el-icon-s-custom"></i> 
                    报名人数:{{content.participant}}<!-- {{}} -->
                </div>
            </div>
            <!-- 这里是参与报名按钮捏 -->
            <div>
                <!-- 这个文字是动态的 -->
                <el-button style="margin-left:60px" type="info" round @click="ClickMeGoContestPage">回顾比赛</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'CanCompete',
        props:['content'],
        data() {
            return {
                obj:""
            }
        },
        methods: {
            ClickMeGoContestPage() {
                console.log("去比赛页面咯")
                let routeData = this.$router.resolve({
                    path:`/contestPage/competeProblem/${this.content.id}`,
                });
                window.open(routeData.href, '_blank');
            }
        },
    }
</script>

<style scoped>
.head {
    margin-top:10px;
    background-color:white;
    width: 100%;
    height: 150px;
    /* margin-left: 2%; */
    display: flex;
    float: left;
    align-items: center;
    border: 1px solid lightgrey;
    border-left: 5px solid #AAB4BF;
}
</style>